<template>
	<div class="updates-popup-overlay">
		<div class="updates-popup" @click.stop>
			<div class="welcome-header">
				<h2 class="welcome-title" v-html="content.title" />
			</div>

			<div class="welcome-content">
				<p v-if="content.message" v-html="content.message"></p>
				<p v-else>
					<span v-if="!content.isActive"><Icon type="matches" class="svg" colour="#a26c67" /> <strong>Meet Your Matches</strong>: See the brand names of your top 18 matches.
					<br><br></span>
					<Icon type="pitch" class="svg" colour="#a26c67" /> <strong>Pitch Area is now called 'Opportunities'</strong>: New name, new look, new updates. See a brand's details from their Opportunity, and if you love a brand but not their current Opportunity, you can send them a direct Request (if they are in your Matches)
					<br><br>
					<Icon type="writing-tool" class="svg" :classes="{ 'no-opacity': true }" colour="#a26c67" /> <strong>Writing Tool</strong>: Our new Writing Tool helps you create an idea and craft the Collab Request or Opportunity that gets a response.
					<br><br>
					<Icon type="doi" class="svg" colour="#a26c67" /> <strong>Dates of Interest Filter</strong>: Find brands open to collaborating on the same dates as you. <span class="link" @click="handleDatesOfInterest">Manage your Dates of Interest here.</span>
					<br><br>
					<Icon type="ideas" class="svg" colour="#a26c67" /> <strong>Ultimate Collab Guide</strong>: Click 'No, help me get started' on your Dashboard and you'll find ideas, tools, tips and everything you need to get confident and collaborate.
				</p>
			</div>

			<div class="welcome-actions">
				<button @click="handleGotIt" class="button get-started-btn">{{ content.cta || "Got it!" }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import { useStore } from "vuex";
import Icon from "../Display/BaseIcon.vue";
import ApiService from "./../../services/api.service";
export default {
	name: "UpdatesPopup",
	components: {
		Icon,
	},
	emits: ["close"],
	props: {
		content: {
			type: Object,
			required: true,
		},
	},
	setup(props, { emit }) {
		const store = useStore();
		const updateVar = (payload) => store.commit("general/updateVar", payload);

		const handleClose = () => {
			ApiService.post(`users/action/updates-popup-2`);
			emit("close");
		};

		const handleGotIt = () => {
			handleClose();
		};

		const handleOverlayClick = () => {
			handleClose();
		};

		const handleDatesOfInterest = () => {
			updateVar({ varName: "showDatesOfInterestModal", info: true });
		};

		return {
			handleClose,
			handleGotIt,
			handleOverlayClick,
			handleDatesOfInterest,
		};
	},
};
</script>

<style scoped lang="less">
@import "./../../assets/css/less/_settings.less";

.updates-popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: @overlayScrimStrong;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.updates-popup {
	position: relative;
	padding: 30px 40px;
	text-align: center;
	max-width: 700px;
	width: 100%;
	background: white;
	border-radius: @radiusXl;
	.elevation.modalWorkspace();
	max-height: 90vh;
	overflow-y: auto;

	.help-text {
		font-size: 14px;
		color: @textGrey;
		line-height: 1.6;
		margin: 10px 0 0;

		.help-text-link {
			color: @formDefaultColour;
			text-decoration: underline;
			cursor: pointer;
		}
	}

	.welcome-header {
		margin-bottom: 25px;

		.welcome-title {
			font-size: 32px;
			font-weight: 700;
			color: @darkContrast;
			margin: 0;
		}

		.welcome-subtitle {
			font-size: 24px;
			font-weight: 600;
			color: @formDefaultColour;
			margin: 0;
		}

		.welcome-description {
			font-size: 16px;
			color: @textGrey;
			line-height: 1.6;
			margin: 0;
		}
	}

	.welcome-content {
		margin-bottom: 25px;

		p {
			span {
				color: inherit;
				&.link {
					text-decoration: underline;
					cursor: pointer;
				}
			}
			.svg {
				width: 1.2rem;
				margin-right: 0.5rem;
			}
		}
	}

	.welcome-actions {
		.get-started-btn {
			font-size: 18px;
			padding: 16px 48px;
			background: @formDefaultColour;
			color: white;
			border: none;
			margin: 0;

			&:hover {
				background: darken(@formDefaultColour, 10%);
			}
		}
	}
}

@media (max-width: 768px) {
	.updates-popup {
		padding: 24px;

		.welcome-header {
			margin-bottom: 30px;

			.welcome-title {
				font-size: 24px;
			}

			.welcome-description {
				font-size: 14px;
			}
		}

		.welcome-steps {
			.step-item {
				padding: 16px;

				.step-icon-wrapper {
					width: 48px;
					height: 48px;
					margin-right: 16px;

					.step-icon {
						font-size: 20px;
					}

					.step-number {
						width: 20px;
						height: 20px;
						font-size: 12px;
					}
				}

				.step-content {
					.step-title {
						font-size: 16px;
					}

					.step-description {
						font-size: 13px;
					}
				}
			}
		}

		.welcome-actions {
			.get-started-btn {
				font-size: 16px;
				padding: 14px 36px;
			}
		}
	}
}
</style>